import React from "react";
import {
  OrderCreatePage,
  OrderCreatePageProps
} from "@orders/order-create/order-create-page";
import { Location } from "../Location";

export class OrderCreateLocation extends Location<OrderCreatePageProps> {
  constructor(props: OrderCreatePageProps) {
    super(props);
  }

  render() {
    return <OrderCreatePage {...this.params} />;
  }

  toURI() {
    return `/dashboard/order/create`;
  }
}
